/*
  GM — Giornale «Il Campo»: la parte interattiva di gm-giornale e gm-articolo.

  - Date scritte per esteso nella lingua della pagina (Intl), e la data del
    giorno in testata. Liquid stampa 16/09/2026 come ripiego: la pagina e'
    in cache, e un «oggi» scritto dal server resterebbe fermo.
  - Video: YouTube (senza cookie), Vimeo o .mp4. Il player si crea solo al
    clic. Nella fascia si apre in una finestra, in testa all'articolo prende
    il posto della copertina. Senza JavaScript sono link normali.
  - Categorie e pagine senza ricaricare: si chiede a Shopify la sola sezione
    (Section Rendering API) e si sostituisce il corpo. I link restano veri.
  - Articolo: barra di avanzamento, indice costruito dagli <h2> che segue la
    lettura, «copia il link».
*/
(function () {
  'use strict';

  var lang = (document.documentElement.lang || 'it').slice(0, 2);

  function scriviDate(root) {
    var giorno, oggi;
    try {
      giorno = new Intl.DateTimeFormat(lang, { day: 'numeric', month: 'long', year: 'numeric' });
      oggi = new Intl.DateTimeFormat(lang, { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
    } catch (e) { return; }
    (root || document).querySelectorAll('time[data-gm-data]').forEach(function (t) {
      var d = new Date((t.getAttribute('datetime') || '') + 'T12:00:00');
      if (!isNaN(d)) t.textContent = giorno.format(d);
    });
    document.querySelectorAll('[data-gm-oggi]').forEach(function (el) {
      var s = oggi.format(new Date());
      el.textContent = s.charAt(0).toUpperCase() + s.slice(1);
    });
  }

  /* ---- Video ------------------------------------------------------------ */
  function creaPlayer(tipo, id, titolo) {
    var el;
    if (tipo === 'yt' && /^[\w-]{6,20}$/.test(id)) {
      el = document.createElement('iframe');
      el.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
    } else if (tipo === 'vimeo' && /^\d+$/.test(id)) {
      el = document.createElement('iframe');
      el.src = 'https://player.vimeo.com/video/' + id + '?autoplay=1&dnt=1';
    } else if (tipo === 'file' && /^(https:)?\/\//.test(id)) {
      el = document.createElement('video');
      el.src = id;
      el.controls = true;
      el.autoplay = true;
      el.playsInline = true;
      el.setAttribute('playsinline', '');
    } else {
      return null;
    }
    if (el.tagName === 'IFRAME') {
      el.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
      el.setAttribute('allowfullscreen', '');
      /* YouTube rifiuta l'embed se non riceve il referrer. */
      el.setAttribute('referrerpolicy', 'strict-origin-when-cross-origin');
      el.title = titolo || '';
    }
    return el;
  }

  var modale = document.querySelector('[data-gm-modale]');
  if (modale) {
    modale.addEventListener('close', function () {
      /* Svuotare il contenitore ferma il video: chiudere la finestra non basta. */
      var p = modale.querySelector('[data-gm-modale-player]');
      if (p) p.textContent = '';
    });
    modale.addEventListener('click', function (e) {
      if (e.target === modale || e.target.closest('[data-gm-modale-chiudi]')) modale.close();
    });
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gm-video]');
    if (!b || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var el = creaPlayer(b.getAttribute('data-gm-tipo'), b.getAttribute('data-gm-id'), b.getAttribute('data-gm-titolo'));
    if (!el) return;

    if (b.hasAttribute('data-gm-inline')) {
      e.preventDefault();
      b.parentNode.replaceChild(el, b);
      return;
    }
    if (!modale || typeof modale.showModal !== 'function') return;
    e.preventDefault();
    modale.querySelector('[data-gm-modale-player]').replaceChildren(el);
    modale.querySelector('[data-gm-modale-titolo]').textContent = b.getAttribute('data-gm-titolo') || '';
    var link = modale.querySelector('[data-gm-modale-link]');
    if (link && b.getAttribute('data-gm-url')) {
      link.href = b.getAttribute('data-gm-url');
      link.hidden = false;
    }
    modale.showModal();
  });

  /* ---- Fascia che scorre ------------------------------------------------ */
  function attivaPiste(root) {
    (root || document).querySelectorAll('[data-gm-pista]').forEach(function (p) {
      if (p.gmPronta) return;
      p.gmPronta = true;
      var frecce = p.parentNode.querySelectorAll('[data-gm-dir]');
      function aggiorna() {
        var fine = p.scrollWidth - p.clientWidth - 2;
        frecce.forEach(function (f) {
          f.disabled = Number(f.getAttribute('data-gm-dir')) < 0 ? p.scrollLeft <= 2 : p.scrollLeft >= fine;
        });
      }
      frecce.forEach(function (f) {
        f.addEventListener('click', function () {
          p.scrollBy({ left: Number(f.getAttribute('data-gm-dir')) * Math.max(p.clientWidth * 0.8, 280), behavior: 'smooth' });
        });
      });
      p.addEventListener('scroll', aggiorna, { passive: true });
      window.addEventListener('resize', aggiorna);
      aggiorna();
    });
  }

  /* ---- Categorie e pagine senza ricaricare ------------------------------ */
  var corpo = document.querySelector('[data-gmgi-corpo]');

  function centraCategoria() {
    var lista = document.querySelector('[data-gmgi-cat] ul');
    var attiva = lista && lista.querySelector('.is-attiva');
    if (!attiva || lista.scrollWidth <= lista.clientWidth) return;
    var dx = attiva.getBoundingClientRect().left - lista.getBoundingClientRect().left;
    lista.scrollLeft += dx - (lista.clientWidth - attiva.offsetWidth) / 2;
  }

  function vai(url, aggiungi) {
    var sezione = corpo.closest('.shopify-section');
    var id = sezione ? sezione.id.replace(/^shopify-section-/, '') : '';
    var richiesta = new URL(url, location.href);
    if (id) richiesta.searchParams.set('section_id', id);

    corpo.classList.add('is-caricando');
    corpo.setAttribute('aria-busy', 'true');
    fetch(richiesta.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuovoCorpo = doc.querySelector('[data-gmgi-corpo]');
        var nuoveCat = doc.querySelector('[data-gmgi-cat]');
        var vecchieCat = document.querySelector('[data-gmgi-cat]');
        if (!nuovoCorpo) throw new Error('sezione assente');
        corpo.innerHTML = nuovoCorpo.innerHTML;
        if (nuoveCat && vecchieCat) vecchieCat.innerHTML = nuoveCat.innerHTML;
        if (aggiungi) history.pushState({ gm: 1 }, '', url);
        scriviDate(corpo);
        attivaPiste(corpo);
        centraCategoria();
        var y = vecchieCat.getBoundingClientRect().top + window.pageYOffset - 90;
        if (window.pageYOffset > y) window.scrollTo({ top: y, behavior: 'smooth' });
      })
      .catch(function () { location.href = url; })
      .then(function () {
        corpo.classList.remove('is-caricando');
        corpo.removeAttribute('aria-busy');
      });
  }

  if (corpo && window.fetch && window.DOMParser && window.URL && history.pushState) {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-gmgi-nav] a, a[data-gmgi-link]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button) return;
      if (a.origin !== location.origin) return;
      e.preventDefault();
      vai(a.href, true);
    });
    history.replaceState({ gm: 1 }, '');
    window.addEventListener('popstate', function (e) {
      if (e.state && e.state.gm) vai(location.href, false);
    });
  }

  /* ---- Articolo --------------------------------------------------------- */
  var testo = document.querySelector('[data-gm-rte]');
  if (testo) {
    var barra = document.querySelector('[data-gm-progresso]');
    var inAttesa = 0;
    var avanza = function () {
      inAttesa = 0;
      var r = testo.getBoundingClientRect();
      var corsa = r.height - window.innerHeight * 0.5;
      var p = corsa > 0 ? (window.innerHeight * 0.25 - r.top) / corsa : 1;
      p = Math.min(1, Math.max(0, p));
      if (barra) barra.style.transform = 'scaleX(' + p.toFixed(4) + ')';
    };
    window.addEventListener('scroll', function () {
      if (!inAttesa) inAttesa = requestAnimationFrame(avanza);
    }, { passive: true });
    avanza();

    var indice = document.querySelector('[data-gm-indice]');
    var titoli = testo.querySelectorAll('h2');
    if (indice && titoli.length >= 2) {
      var ol = indice.querySelector('ol');
      var voci = [];
      titoli.forEach(function (h, i) {
        if (!h.id) {
          h.id = 's' + (i + 1) + '-' + h.textContent.toLowerCase()
            .normalize('NFD').replace(/[̀-ͯ]/g, '')
            .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 48);
        }
        var li = document.createElement('li');
        var a = document.createElement('a');
        a.href = '#' + h.id;
        a.textContent = h.textContent.trim();
        li.appendChild(a);
        ol.appendChild(li);
        voci.push(a);
      });
      indice.hidden = false;

      var largo = window.matchMedia('(min-width: 990px)');
      var apri = function () { if (largo.matches) indice.open = true; };
      apri();
      if (largo.addEventListener) largo.addEventListener('change', apri);
      indice.addEventListener('click', function (e) {
        if (largo.matches && e.target.closest('summary')) e.preventDefault();
        if (!largo.matches && e.target.closest('a')) indice.open = false;
      });

      if ('IntersectionObserver' in window) {
        var osserva = new IntersectionObserver(function (voce) {
          voce.forEach(function (v) {
            if (!v.isIntersecting) return;
            voci.forEach(function (a) { a.classList.toggle('is-attivo', a.getAttribute('href') === '#' + v.target.id); });
          });
        }, { rootMargin: '-15% 0px -75% 0px' });
        titoli.forEach(function (h) { osserva.observe(h); });
      }
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-gm-copia]');
    if (!b || !navigator.clipboard) return;
    var etichetta = b.querySelector('[data-gm-copia-testo]');
    var prima = etichetta.textContent;
    navigator.clipboard.writeText(location.href.split('#')[0]).then(function () {
      etichetta.textContent = b.getAttribute('data-gm-copiato');
      setTimeout(function () { etichetta.textContent = prima; }, 2000);
    }, function () {});
  });

  /* Una tabella che scorre in orizzontale deve poter prendere il fuoco, o chi
     naviga da tastiera non puo' farla scorrere (WCAG 2.1.1). Il corpo
     dell'articolo e' tradotto in sei lingue: si aggancia da qui, non si tocca
     il testo. */
  function tabelleScorrevoli() {
    var rte = document.querySelector('[data-gm-rte]');
    if (!rte) return;
    var nome = rte.getAttribute('data-gm-tabella') || '';
    rte.querySelectorAll('table').forEach(function (t) {
      if (t.scrollWidth <= t.clientWidth + 1) return;
      if (t.getAttribute('tabindex') !== null) return;
      t.setAttribute('tabindex', '0');
      t.setAttribute('role', 'group');
      if (nome) t.setAttribute('aria-label', nome);
    });
  }

  scriviDate();
  attivaPiste();
  centraCategoria();
  tabelleScorrevoli();
  window.addEventListener('resize', tabelleScorrevoli);
})();
